module.exports = __webpack_public_path__ + "static/media/shoe-cleaning-service-icon.63f5ef49.svg";